import register from '@kpsys/angularjs-register';
import acquisitionRoutes from './acquisition.routes';
import {KpAcquisitionService} from './kp-acquisition.service';

export default register('portaro.features.acquisition')
    .config(acquisitionRoutes)
    .service(KpAcquisitionService.serviceName, KpAcquisitionService)
    .name();
